"use client"; // Indicate this is a client component

import { useEffect } from "react";
import PageLayout from "@/components/_shared/PageLayout";
import AuthenticatedPageWrapper from "@/components/auth/AuthenticatedPageWrapper";
import TextShareForm from "@/components/text-share/TextShareForm";

// Define the specific instructions for this page

export default function TextSharePage() {
	useEffect(() => {
		document.title = "Text-Share";
	}, []);

	// Function to identify localStorage keys to delete
	const handleDelete = () => {
		// textShare_nutzerHash entfernt
		const keysToDelete: string[] = [];
		Object.keys(localStorage).forEach((key) => {
			if (
				key.startsWith("tinymce-autosave") ||
				key.startsWith("tinymce-state") ||
				key.startsWith("tinymce-") ||
				key.includes("textshare") // Behalte dies, um TinyMCE-spezifische Daten zu löschen
			) {
				keysToDelete.push(key);
			}
		});
		return keysToDelete;
	};

	return (
		<PageLayout
			additionalItemsToDelete={handleDelete()}
			title="Text-Share" // toolId kann bleiben für generische Einstellungen, falls vorhanden
			toolId="text-share"
		>
			<AuthenticatedPageWrapper toolName="Text-Share">
				<main className="grid grid-cols-1 gap-6">
					<TextShareForm />
				</main>
			</AuthenticatedPageWrapper>
		</PageLayout>
	);
}
